import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

import { IconProps } from '../icons'

const UnAssignedUserError = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 25"
    fill="none"
    {...props}
  >
    <G clipPath="url(#a)" fill="#2F3440">
      <Path d="M13.53 12.02s-.01-.06-.02-.09c1.67-.6 2.87-2.18 2.87-4.06 0-2.39-1.94-4.33-4.33-4.33S7.72 5.48 7.72 7.87c0 1.49.76 2.81 1.91 3.59-3.72.68-6.54 3.78-6.54 7.49v.78c0 .39.31.7.7.7.39 0 .7-.31.7-.7v-.78c0-3.43 2.99-6.23 6.67-6.23h1.66c.39 0 .7-.31.7-.7h.01Zm-4.4-4.14c0-1.61 1.31-2.93 2.93-2.93s2.93 1.31 2.93 2.93-1.31 2.93-2.93 2.93S9.13 9.5 9.13 7.88ZM17 12.03a4.2 4.2 0 1 0-.001 8.4 4.2 4.2 0 0 0 .001-8.4Zm0 7c-1.54 0-2.8-1.26-2.8-2.8 0-1.54 1.26-2.8 2.8-2.8 1.54 0 2.8 1.26 2.8 2.8 0 1.54-1.26 2.8-2.8 2.8Z" />
      <Path d="m17.41 16.97.1-2.97h-1.02l.1 2.97h.82ZM17 17.36c-.32 0-.55.24-.55.55 0 .31.23.54.55.54.32 0 .54-.23.54-.54 0-.31-.23-.55-.54-.55Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" transform="translate(0 .5)" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default UnAssignedUserError
